import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import Originators from "@/pages/Pages/Senders/Originators.vue";
import Originator from "@/pages/Pages/Senders/Originator.vue";
import Distributions from "@/pages/Pages/Distributions/Distributions.vue";
import SmsDistribution from "@/pages/Pages/Distributions/SmsDistribution.vue";
import CallDistribution from "@/pages/Pages/Distributions/CallDistribution.vue";
import EmailDistribution from "@/pages/Pages/Distributions/EmailDistribution.vue";
import PushDistribution from "@/pages/Pages/Distributions/PushDistribution.vue";
import ViberDistribution from "@/pages/Pages/Distributions/ViberDistribution.vue";
import WhatsappDistribution from "@/pages/Pages/Distributions/WhatsappDistribution.vue";
import CustomDistribution from "@/pages/Pages/Distributions/CustomDistribution.vue";
import MailNotifyDistribution from "@/pages/Pages/Distributions/MailNotifyDistribution.vue";

let reportMenu = {
  path: "/",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: "sender",
      name: "sender",
      component: Originators,
      meta: {
        icon: "alternate_email",
        msgKey: 'menu.item.originators'
      }
    },
    {
      path: "sender/new",
      name: "sender_new",
      component: Originator,
      meta: {
        parentPath: "/sender",
        msgKey: 'menu.item.originators'
      }
    },
    {
      path: "distribution",
      name: "distribution_list",
      component: Distributions,
      meta: {
        icon: "reply_all",
        msgKey: 'menu.item.distr.status'
      }
    },
    {
      path: "distribution/sms/new",
      name: "distribution_sms_new",
      component: SmsDistribution,
      meta: {
        icon: "sms",
        msgKey: 'menu.item.distr.create.sms'
      }
    },
    {
      path: "distribution/call/new",
      name: "distribution_call_new",
      component: CallDistribution,
      meta: {
        icon: "call",
        msgKey: 'menu.item.distr.create.call'
      }
    },
    {
      path: "distribution/email/new",
      name: "distribution_email_new",
      component: EmailDistribution,
      meta: {
        icon: "email",
        msgKey: 'menu.item.distr.create.email'
      }
    },
    {
      path: "distribution/push/new",
      name: "distribution_push_new",
      component: PushDistribution,
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.distr.create.push'
      }
    },
    {
      path: "distribution/viber/new",
      name: "distribution_viber_new",
      component: ViberDistribution,
      meta: {
        icon: "forum",
        msgKey: 'menu.item.distr.create.viber'
      }
    },
    {
      path: "distribution/whatsapp/new",
      name: "distribution_whatsapp_new",
      component: WhatsappDistribution,
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.distr.create.whatsapp'
      }
    },
    {
      path: "distribution/custom/new",
      name: "distribution_custom_new",
      component: CustomDistribution,
      meta: {
        icon: "inbox",
        msgKey: 'menu.item.distr.create.custom'
      }
    },
    {
      path: "distribution/mail_notify/new",
      name: "distribution_mail_notify_new",
      component: MailNotifyDistribution,
      meta: {
        icon: "mark_email_unread",
        msgKey: 'menu.item.distr.create.mail_notify'
      }
    },
  ]
};

export default reportMenu;